import { Button, Flex, Input, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { CloudConnectionDemoHint } from "@/pages/DeploymentsPage/components/molecules/CloudConnectionStatus"

import type { FoundryDemoConnectProps } from "./FoundryTab.types"

// The demo connects nothing: the subscription entered fills the grant
// command, and Connect stays off
export const FoundryDemoConnect = ({
  subscriptionId,
  onSubscriptionIdChange
}: FoundryDemoConnectProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.foundry.cloud"
  })

  return (
    <Flex vertical gap={12}>
      <Flex vertical gap={4}>
        <Text>{t("fields.subscriptionId.label")}</Text>
        <Input
          value={subscriptionId}
          aria-label={t("fields.subscriptionId.label")}
          placeholder={t("fields.subscriptionId.placeholder")}
          onChange={(e) => onSubscriptionIdChange(e.target.value)}
        />
      </Flex>
      <Flex gap={8} align="center">
        <Button type="primary" disabled>
          {t("connect")}
        </Button>
        <CloudConnectionDemoHint />
      </Flex>
    </Flex>
  )
}
